module.exports = __webpack_public_path__ + "img/highcost.d952f3e.png";